<template>
    <div class="system-picture-upload">
        <el-upload
            ref="upload"
            action=""
            class="upload-demo"
            :http-request="submitUpload"
            :show-file-list="false"
            :auto-upload="true"
            list-type="picture-card"
            accept="image/jpeg,image/jpg,image/png">
            <i class="el-icon-plus"></i>
            <div class="el-upload__tip title" slot="tip">
                {{$translate('lang.E3202103170026', { defaultText: '上传图片不能超过5M' })}}
            </div>
        </el-upload>
    </div>
</template>
<script>
import { uploadPictures } from '../../api/product';
const BYTES_PER_CHUNK = 5 * 1024 * 1024;
export default {
    data() {
        return {
            downUrl: null
        };
    },
    methods: {
        submitUpload(uploadData) {
            if (uploadData.file.type === 'image/jpeg' || uploadData.file.type === 'image/jpg' || uploadData.file.type === 'image/png') {
                if (uploadData.file.size > BYTES_PER_CHUNK) {
                    this.$message.warning(this.$translate('lang.E3202103170027', { defaultText: '图片上传只支持5M以内' }));
                    this.$refs.upload.clearFiles();
                } else {
                    this.simpleUpload(uploadData);
                }
            } else {
                this.$message.warning(this.$translate('lang.E3202103170028', { defaultText: '图片上传类型不正确' }));
                this.$refs.upload.clearFiles();
            }
        },
        // 视频上传测试
        simpleUpload(uploadData) {
            const form = new FormData();
            form.append('file', uploadData.file);
            uploadPictures(form).then(res => {
                if (res.code === '0') {
                    this.downUrl = res.data.downUrl;
                    this.$emit('pushImg', res.data.downUrl);
                    this.$refs.upload.clearFiles();
                }
            }).catch(() => {
                this.$refs.upload.clearFiles();
            });
        }
    }
};
</script>
<style lang="less">
.system-picture-upload{
    .title{
        font-family: 'PingFangSC-Regular';
        font-size: 12px;
        color: rgba(0,0,0,0.25);
        line-height: 22px;
        text-align:center;
    }
}
</style>